module.exports = __webpack_public_path__ + "img/icon_avatar.e221e3c4.png";